
import React, { useEffect, useState } from "react";
import { socket, camelCase } from '../../../helpers/global_helper';


const SuperWheelResult = (props) => {

    const roomColorNumber = {
        'WH': {
            "1": { backgroundColor: "#0F1A1C", color: "#FFFFFF" }, // DarkGreen
            "2": { backgroundColor: "#EED640", color: "#000" }, // Sandstorm Yellow
            "5": { backgroundColor: "#0072BB", color: "#FFFFFF" }, // French Blue
            "8": { backgroundColor: "#A03260", color: "#FFFFFF" }, // Red Purple
            "10": { backgroundColor: "#801818", color: "#FFFFFF" }, // Falu Red
            "15": { backgroundColor: "#FF7518", color: "#000000" }, // Pumpkin
            "20": { backgroundColor: "#D0B6BF", color: "#000" }, // Silver Pink
            "30": { backgroundColor: "#1F305E", color: "#FFFFFF" }, // Delft Blue
            "40": { backgroundColor: "#FF66CC", color: "#000000" } // Persian Pink
        }
    };

    const roomDigit = {
        "One": "1",
        "Two": "2",
        "Five": "5",
        "Eight": "8",
        "Ten": "10",
        "Fifteen": "15",
        "Twenty": "20",
        "Thirty": "30",
        "Forty": "40"
    };
    const [result, setResult] = useState([]);
    const [resultNumber, setResultNumber] = useState([]);

    useEffect(() => {
        socket.on("game_history", (result) => {
            if (result.room_id == props.room_id) {
                if (result.status != 'success') {
                    return;
                }
                let temp = [];
                let tempResultNumber = [];
                for (let key in result.results) {
                    if (key == 'numbers')
                        continue;
                    temp.push({ key: camelCase(key), value: result.results[key] });
                }
                for (let key in result.results.numbers) {
                    tempResultNumber.push(result.results.numbers[key].value.toString());
                }
                setResultNumber([...tempResultNumber]);
                setResult([...temp]);
            }
        });
    }, [resultNumber]);

    useEffect(() => {
        socket.emit("game_history", { room_id: props.room_id });
    }, [props.room_id]);
    
    return (
        <div className='sw_result'>
            <ul>
                {result.length > 0 && result.map((obj, index) => {
                    return (
                        <li key={index}><span>{roomDigit[obj.key]}</span><span>:</span><span className="game_ding_dong_blue">{parseInt(obj.value)}%</span></li>
                    )
                })}
            </ul>
            <div className='sw_circle_result'>
                {resultNumber.length > 0 ? (
                    <div
                        className='sw_circle_current_num'
                        style={{
                            backgroundColor: (roomColorNumber[props.game_code]) ? roomColorNumber[props.game_code][resultNumber[0]].backgroundColor : 'black',
                            color: (roomColorNumber[props.game_code]) ? roomColorNumber[props.game_code][resultNumber[0]].color : 'white'
                        }}
                    >
                        {resultNumber[0]}
                    </div>
                ) : ''}
                <div className='sw_num_list'>
                    {resultNumber.map((value, index) => {
                        return (
                            <React.Fragment key={index}>
                                {index !== 0 ? (
                                    <div
                                        className='sw_num'
                                        style={{
                                            backgroundColor: (roomColorNumber[props.game_code]) ? roomColorNumber[props.game_code][value].backgroundColor : 'black',
                                            color: (roomColorNumber[props.game_code]) ? roomColorNumber[props.game_code][value].color : 'white'
                                        }}
                                    >
                                        {value}
                                    </div>
                                ) : ''}
                            </React.Fragment>

                        )
                    })}
                </div>
            </div>

        </div>
    )
}

export default SuperWheelResult